















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Tab extends Vue {
  @Prop()
  private name!: string;
  @Prop()
  private path!: string;
  @Prop()
  private isSelected!: boolean;
  @Prop()
  private isDeleted!: boolean;
  @Prop()
  private onClickDeleteTab!: (tabPath: string) => void;
  @Prop()
  private onClickTab!: (tabPath: string) => void;

  private doDelete: boolean = false;

  private handleClickDeleteTab(e: MouseEvent) {
    this.doDelete = true;
    this.onClickDeleteTab(this.path);
  }

  private handleClickTab(): void {
    if (this.doDelete) {
      this.doDelete = false;
    } else {
      this.onClickTab(this.path);
    }
  }
}
